var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06167 0.749987C6.06167 0.633059 5.99184 0.527432 5.88425 0.481629C5.77667 0.435826 5.65213 0.4587 5.56784 0.539744L4.5307 1.53699C2.98649 3.02182 1.68167 4.73694 0.662687 6.62131C0.638695 6.66368 0.625 6.71265 0.625 6.76482C0.625 6.9259 0.755584 7.05648 0.916667 7.05648H3.43083V11.25C3.43083 11.3655 3.49899 11.4701 3.60464 11.5168C3.71029 11.5635 3.83353 11.5434 3.91891 11.4656L4.38296 11.0429C6.00738 9.56316 7.38593 7.83432 8.46689 5.92124L8.75393 5.41324C8.80496 5.32294 8.80419 5.21234 8.75191 5.12276C8.69963 5.03318 8.60372 4.9781 8.5 4.9781H6.06167V0.749987Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightning);
export default __webpack_public_path__ + "static/media/ic_lightning.d1193f856df573453a8476836e9e8582.svg";
export { ForwardRef as ReactComponent };